/* eslint-disable import/first */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

Vue.config.productionTip = false

/**
 * Import and register/install third-party components.
 */
import BootstrapVue from 'bootstrap-vue'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'

Vue.use(BootstrapVue)
Vue.component('icon', Icon)

/**
 * Import and register/install application components.
 */
import App from './App.vue'
import router from './router'
import store from './store'
import Components from './components'
import Filters from './filters'
import SafeIdMixin from './mixins/safe-id'
import Shortcut from '@/plugins/shortcut'

Components.install(Vue)
Filters.install(Vue)
Vue.mixin(SafeIdMixin)
Vue.use(Shortcut)

/**
 * Create root vue instance
 */
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js